module.exports = __webpack_public_path__ + "assets/img/e230a63dc9443c3e62d0e4b6426f4527.svg";